import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export type ModalType = {
  modalName: string;
  modalOpen: boolean;
  styles: object;
};

const initialState: ModalType = {
  modalName: '',
  modalOpen: false,
  styles: {},
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (state, action) => {
      const { modalName, styles } = action.payload;
      state.modalName = modalName;
      state.styles = styles;
      state.modalOpen = true;
    },
    closeModal: () => {
      return initialState;
    },
  },
});

export const { openModal, closeModal } = modalSlice.actions;
export const selectModalProps = (state: RootState) => state.modal;
export default modalSlice.reducer;
